import type { Profile, TaskType, UUID } from "@/core/types";
import { provider_pcp } from "@/config/roles";
import type { RootState } from "@/lib/types/state";

export const selectProfile = (state: RootState): Profile | undefined => {
  return state?.auth?.profile;
};

export const selectPatientId = (state: RootState): undefined | UUID => {
  return state?.auth?.profile?.username;
};

export const selectRole = (state: RootState): null | string | undefined => {
  return state?.auth?.role;
};

export const selectIsUserPCP = (state: RootState): boolean => state?.auth?.role === provider_pcp;

export const selectDaysUntilPasswordReset = (state: RootState): null | number | undefined => {
  return state?.auth?.daysUntilPasswordReset;
};

export const selectIsPatientInactive = (state: RootState): boolean =>
  state?.auth?.profile?.status === "INACTIVE";

export const selectIsHCPPendingCancellationAcknowledgement = (state: RootState): boolean => {
  const profile = state?.auth?.profile;
  const acknowledgements = profile?.acknowledgements as Record<string, unknown> | null | undefined;

  return !!(
    profile?.group_type === "hcp_program" && !("hcp_auto_cancellation" in (acknowledgements ?? {}))
  );
};

export const selectIsPatientWaitListed = (state: RootState): boolean =>
  state?.auth?.profile?.is_wait_listed === true;

export const selectShouldShowHCPDIModal = (state: RootState): boolean => {
  const profile = state?.auth?.profile;
  const acknowledgements = profile?.acknowledgements as Record<string, unknown> | null | undefined;

  return !!(
    profile &&
    profile.group_type === "hcp_program" &&
    profile.schedule_video_call &&
    !(acknowledgements?.hcp_di_reminder ?? false) &&
    profile.status !== "INACTIVE"
  );
};

export const selectTaskIdByType = (state: RootState, taskType: TaskType): undefined | UUID => {
  const tasks = state?.auth?.profile?.tasks;
  const task = tasks?.find((task) => task.task_type === taskType);

  return task?.task_id;
};
